export default __webpack_public_path__ + "static/media/sb.256377e0.png";